module.exports = "/_next/static/images/wf-8bad31901955ce9de770f2b724daa403.svg";